import {default as Card} from './Card';
export default Card;
